// @flow
import { ACTIONS_NAMESPACE as CB_ACTIONS_NAMESPACE } from 'esm-web-pro/redux/constants';

export const MOUNT_POINT = 'landingTab';

export const ACTIONS_NAMESPACE = `${CB_ACTIONS_NAMESPACE}/LANDING_TAB`;
export const SET_LANDING_TAB = `${ACTIONS_NAMESPACE}/SET_LANDING_TAB`;
export const SET_LANDING_TAB_IN_SAME_BROWSER = `${ACTIONS_NAMESPACE}/SET_LANDING_TAB_IN_SAME_BROWSER`;
